// state/reducers/deliveryReducer.js
import {
    FETCH_DELIVERIES_REQUEST,
    FETCH_DELIVERIES_SUCCESS,
    FETCH_DELIVERIES_FAILURE,
    UPDATE_DELIVERY_STATUS_REQUEST,
    UPDATE_DELIVERY_STATUS_SUCCESS,
    UPDATE_DELIVERY_STATUS_FAILURE,
    FETCH_DRIVER_TOTAL_DISTANCE_REQUEST,
    FETCH_DRIVER_TOTAL_DISTANCE_SUCCESS,
    FETCH_DRIVER_TOTAL_DISTANCE_FAILURE,
    RESET_DRIVER_TOTAL_DISTANCE,
} from '../actions/types';

const initialState = {
    deliveries: [],
    loading: false,
    error: null,
    message: '',
    updatingStatus: false,
    updateError: null,
    driverTotalDistance: null,
    driverDistanceLoading: false,
    driverDistanceError: null,
};

export default function deliveryReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_DELIVERIES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_DELIVERIES_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveries: action.payload,
                message: 'Deliveries loaded successfully',
            };

        case FETCH_DELIVERIES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                deliveries: [],
            };

        // Handling delivery status update actions
        case UPDATE_DELIVERY_STATUS_REQUEST:
            return { ...state, updatingStatus: true, updateError: null };

        case UPDATE_DELIVERY_STATUS_SUCCESS:
            return {
                ...state,
                updatingStatus: false,
                deliveries: state.deliveries.map((delivery) =>
                    delivery.delivery_id === action.payload.delivery_id
                        ? { ...delivery, status: action.payload.status }
                        : delivery
                ),
                message: 'Delivery status updated successfully',
            };

        case UPDATE_DELIVERY_STATUS_FAILURE:
            return {
                ...state,
                updatingStatus: false,
                updateError: action.payload,
            };

        case FETCH_DRIVER_TOTAL_DISTANCE_REQUEST:
            return {
                ...state,
                driverDistanceLoading: true,
                driverDistanceError: null,
            };

        case FETCH_DRIVER_TOTAL_DISTANCE_SUCCESS:
            return {
                ...state,
                driverDistanceLoading: false,
                driverTotalDistance: action.payload,
            };

        case FETCH_DRIVER_TOTAL_DISTANCE_FAILURE:
            return {
                ...state,
                driverDistanceLoading: false,
                driverDistanceError: action.payload,
            };
        case RESET_DRIVER_TOTAL_DISTANCE:
            return {
                ...state,
                driverTotalDistance: null,
                driverDistanceLoading: false,
                driverDistanceError: null,
            };

        default:
            return state;
    }
}
